<app-operaciones-usuario [titulo]="titulo" [usuarios]="usuariosDatosViejos" [operacion]="operacion"
    (funcion)="verModificacionUsuario($event)" (refresh)="refresh()"></app-operaciones-usuario>